/**
 * Created by jv on 25/05/2018.
 */
import LanguageManager from "Sources/services/language-manager";

function getText()
{
  return {
    menu: {
      title: LanguageManager.getValueForKey("games.chicken.game.title"),
      controlsDescription: [
        LanguageManager.getValueForKey("games.chicken.game.description.line1"),
        LanguageManager.getValueForKey("games.chicken.game.description.line2"),
        LanguageManager.getValueForKey("games.chicken.game.description.line3"),
        "",
        LanguageManager.getValueForKey("games.chicken.game.description.line5"),
        LanguageManager.getValueForKey("games.chicken.game.description.line6")
      ],
      playBtn: LanguageManager.getValueForKey("games.chicken.game.start.btn"),
      resumeBtn: LanguageManager.getValueForKey("games.chicken.game.resume.btn")
    },
    gameOver: {
      title: LanguageManager.getValueForKey("games.chicken.game.gameover.title"),
      highScore: LanguageManager.getValueForKey("games.chicken.game.gameover.highscore"),
      replayBtn: LanguageManager.getValueForKey("games.chicken.game.gameover.replay.btn")
    }
  };
}

export default getText;



// WEBPACK FOOTER //
// ./app/js/games/chicken-game/config/text.js